module.exports = __webpack_public_path__ + "media/images/articles/interview/img04-37adacaaa96e41f5ebd18988772165f6.png";